import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function useMarketPredictionAccess() {
  return usePostHogFeatureFlags(POSTHOG_FEATURES.MARKET_PREDICTION)
}
